import { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { images } from "@utils/media";
import {
  DisplayGameTransitionEvent,
  PreloadAudioEvent,
  PlayPreloadAudioEvent,
  WarsEvents,
} from "@playroomkit/pr-wars/events";

const TransitionUI = () => {
  const controls = useAnimation();

  useEffect(() => {
    const boundPlayAnimationEvent = async (event: Event) => {
      const e = event as DisplayGameTransitionEvent;
      const waitFor = e?.waitFor ?? 0;

      document.dispatchEvent(
        new PlayPreloadAudioEvent("sfx", "transition-sfx", 0.3, false)
      );

      await controls.start({
        scale: [0, 2.5], // ✅ bigger final scale
        rotate: [-360, 0],
        transition: {
          type: "tween",
          duration: 0.7,
          ease: [0.42, 0, 0.58, 1],
        },
      });

      // Pause
      await new Promise((res) => setTimeout(res, waitFor * 1000));

      await controls.start({
        scale: [2.5, 0],
        rotate: [0, 360],
        transition: {
          type: "tween",
          duration: 0.7,
          ease: [0.42, 0, 0.58, 1],
        },
      });
    };

    document.addEventListener(
      WarsEvents.DisplayGameTransitionEvent,
      boundPlayAnimationEvent
    );

    return () => {
      document.removeEventListener(
        WarsEvents.DisplayGameTransitionEvent,
        boundPlayAnimationEvent
      );
    };
  }, [controls]);

  useEffect(() => {
    document.dispatchEvent(
      new PreloadAudioEvent(
        "sfx",
        "transition-sfx",
        "audio/sfx/TransitionSFX.mp3"
      )
    );
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 10,
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <motion.img
        src={images.Transition}
        alt="Transition"
        animate={controls}
        initial={{ scale: 0, rotate: -360 }}
        style={{
          width: "50vw", // ✅ smaller base size
          height: "auto",
          objectFit: "contain",
          transformOrigin: "center center",
          willChange: "transform",
        }}
      />
    </div>
  );
};

export default TransitionUI;
